<div class="header">
    Filters
    <div
        class="mobile-close-icon"
        (click)="close()">
        &#x2715;
    </div>
</div>
<form [formGroup]="form">
    <div class="filters-body">
        <div class="filters-row">
            <div class="filtet-row-label">Type of Stone</div>
            <div class="filter-types">
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === null }"
                    (click)="form.controls.type.setValue(null)">
                    All
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'paving' }"
                    (click)="form.controls.type.setValue('paving')">
                    Paving
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'crazyPaving' }"
                    (click)="form.controls.type.setValue('crazyPaving')">
                    Crazy Paving
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'coping' }"
                    (click)="form.controls.type.setValue('coping')">
                    Coping
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'steps' }"
                    (click)="form.controls.type.setValue('steps')">
                    Steps
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'setts' }"
                    (click)="form.controls.type.setValue('setts')">
                    Setts
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'walling' }"
                    (click)="form.controls.type.setValue('walling')">
                    Walling
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'rockery' }"
                    (click)="form.controls.type.setValue('rockery')">
                    Rockery Stone
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.type.value === 'piercaps' }"
                    (click)="form.controls.type.setValue('piercaps')">
                    Pier Caps
                </div>

            </div>
        </div>
        <div class="filters-row">
            <div class="filtet-row-label">Unit Type</div>
            <div class="filter-types">
                <div
                    class="filter-button selected"
                    [ngClass]="{ selected: form.controls.sellUnit.value === null }"
                    (click)="form.controls.sellUnit.setValue(null)">
                    All
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.sellUnit.value === 'PSM' }"
                    (click)="form.controls.sellUnit.setValue('PSM')">
                    Sqm
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.sellUnit.value === 'ST' }"
                    (click)="form.controls.sellUnit.setValue('ST')">
                    Tonne
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.sellUnit.value === 'P' }"
                    (click)="form.controls.sellUnit.setValue('P')">
                    Piece
                </div>
            </div>
        </div>
        <div class="filters-row">
            <div class="filtet-row-label">Size</div>
            <div class="filter-inputs">
                <div class="filter-input-holder">
                    <div class="filter-input-label">Min width</div>
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input"
                            type="text"
                            formControlName="minWidth"
                            placeholder="Set min width"
                            [readonly]="form.controls.randomWidth.value" />
                        <div class="filter-measure">mm</div>
                    </div>
                    <div class="filter-checkbox-holder">
                        <input
                            type="checkbox"
                            formControlName="randomWidth"
                            class="filter-checkbox" /><span>Random</span>
                    </div>
                </div>
                <div class="filter-input-holder">
                    <div class="filter-input-label">Max width</div>
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input"
                            type="text"
                            formControlName="maxWidth"
                            placeholder="Set max width"
                            [readonly]="!!form.controls.randomWidth.value" />
                        <div class="filter-measure">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filters-row">
            <div class="filter-inputs">
                <div class="filter-input-holder">
                    <div class="filter-input-label">Min length</div>
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input"
                            type="text"
                            formControlName="minLength"
                            placeholder="Set min length"
                            [readonly]="!!form.controls.randomLength.value" />
                        <div class="filter-measure">mm</div>
                    </div>
                    <div class="filter-checkbox-holder">
                        <input
                            type="checkbox"
                            formControlName="randomLength"
                            class="filter-checkbox" /><span>Random</span>
                    </div>
                </div>
                <div class="filter-input-holder">
                    <div class="filter-input-label">Max length</div>
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input"
                            formControlName="maxLength"
                            type="text"
                            placeholder="Set max length"
                            [readonly]="form.controls.randomLength.value" />
                        <div class="filter-measure">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filters-row">
            <div class="filter-inputs">
                <div class="filter-input-holder">
                    <div class="filter-input-label">Min thickness</div>
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input"
                            type="text"
                            formControlName="minThickness"
                            placeholder="Set min thickness" />
                        <div class="filter-measure">mm</div>
                    </div>
                </div>
                <div class="filter-input-holder">
                    <div class="filter-input-label">Max thickness</div>
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input"
                            type="text"
                            formControlName="maxThickness"
                            placeholder="Set max thickness" />
                        <div class="filter-measure">mm</div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="filters-row">
            <div class="filtet-row-label">Price Methods</div>
            <div class="filter-types">
                <div
                    class="filter-button selected"
                    [ngClass]="{ selected: form.controls.sellUnit.value === null }"
                    (click)="form.controls.sellUnit.setValue(null)">
                    All
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.sellUnit.value === 'PSM' }"
                    (click)="form.controls.sellUnit.setValue('PSM')">
                    per Batch
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.sellUnit.value === 'ST' }"
                    (click)="form.controls.sellUnit.setValue('ST')">
                    per Qty
                </div>
                <div
                    class="filter-button"
                    [ngClass]="{ selected: form.controls.sellUnit.value === 'P' }"
                    (click)="form.controls.sellUnit.setValue('P')">
                    Mixed
                </div>
            </div>
        </div>-->

        <div class="filters-row">
            <div class="filtet-row-label">Price</div>
            <from [formGroup]="sliderForm">
                <ngx-slider
                    formControlName="sliderControl"
                    [options]="options"></ngx-slider
            ></from>
            <div class="filter-inputs">
                <div class="filter-input-holder">
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input price"
                            type="text"
                            formControlName="minPrice"
                            placeholder="Set min price" />
                    </div>
                </div>
                <div class="filter-input-holder">
                    <div class="filter-input-with-measure">
                        <input
                            class="filter-input price"
                            formControlName="maxPrice"
                            type="text"
                            placeholder="Set max price" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="bottom-buttons">
    <button
        type="button"
        class="btn btn-outline-primary cancel-btn"
        (click)="close()">
        Cancel
    </button>
    <button
        type="button"
        class="btn btn-primary apply-btn"
        (click)="apply()">
        Show {{ numberOfresults }} results
    </button>
</div>
